// extracted by mini-css-extract-plugin
export default {"searchInput":"Header_searchInput__jMSRD","ulSearchResults":"Header_ulSearchResults__jDfA3","liSearchResultsItem":"Header_liSearchResultsItem__9EufI"};